import { AzureStorageLinkedService, IModel, IAttribute, ModelConstants } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { HDInsightLinkedService } from '../linkedservice/hdinsight.linkedservice';
import { Activity } from './activity';

import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';
import { ParameterConfig } from 'app/model/pipeline/parameter-config';
import { HDInsightOnDemandLinkedService } from 'app/model/linkedservice/hdinsightondemand.linkedservice';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: ModelConstants.sparkActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.Spark_DisplayText),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.Spark_DisplayText)
    ],
    referable: true
})
export class SparkActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly ROOT_PATH: IAttribute;
    public static readonly ENTRY_FILE_PATH: IAttribute;
    public static readonly PROXY_USER: IAttribute;
    public static readonly ARGUMENTS: IAttribute;

    public configType: 'Script' | 'Jar';

    @Metamodel.attribute({
        display: stringResources.ModelName_RootPath,
        constraint: {
            required: true
        },
        association: 'ROOT_PATH',
        templatable: true
    })
    public rootPath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_EntryFilePath,
        constraint: {
            required: true
        },
        association: 'ENTRY_FILE_PATH',
        templatable: true
    })
    public entryFilePath?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Arguments,
        association: 'ARGUMENTS',
        templatable: true,
        accepts: ['Array']
    })
    public sparkActivityArguments?: ParameterConfig[]; // Property name is "arguments" in JSON, needs to workaround with tslint for banned term.
    public getDebugInfo?: string;
    @Metamodel.attribute({
        display: stringResources.ModelName_ClassName
    })
    public className?: string;

    @Metamodel.attribute({
        display: stringResources.SparkActivityProxyUser,
        association: 'PROXY_USER',
        templatable: true
    })
    public proxyUser?: string;

    @Metamodel.attribute({
        display: stringResources.SparkConfiguration,
        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public sparkConfig?: ParameterConfig[];

    @Metamodel.attribute({
        display: stringResources.ModelName_JobLinkedService,
        reference: true,
        type: AzureStorageLinkedService.MODEL
    })
    public sparkJobLinkedService?: AzureStorageLinkedService; // Azure Storage linked service which contains the script.

    @Metamodel.attribute({
        display: format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Hdi_DisplayName),
        constraint: {
            required: true
        },
        reference: true,
        type: HDInsightLinkedService.MODEL
    })
    public linkedService?: HDInsightLinkedService | HDInsightOnDemandLinkedService; // HDInsight linked service which hosts the Spark cluster.

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ExecutionActivity';
    }
}
